import { BaseService } from "./base.service";
import { IEvaluationFunctionalityType } from "models/EvaluationFunctionalityTypeModel";

class EvaluationFunctionalityTypeServiceInternal extends BaseService {
	getEvaluationFunctionalityTypeList = async (): Promise<
		IEvaluationFunctionalityType[]
	> =>
		this.callApi<IEvaluationFunctionalityType[]>(
			`EvaluationFunctionalityType/GetAll`,
			"GET"
		);
}

export const EvaluationFunctionalityTypeService =
	new EvaluationFunctionalityTypeServiceInternal();
